/** The five tabs, in the app's order. */
export const TABS = [
  { path: "/today", label: "Today" },
  { path: "/friends", label: "Friends" },
  { path: "/talk", label: "Talk" },
  { path: "/life", label: "Life" },
  { path: "/you", label: "You" },
] as const;
